import React from "react";

const containerStyle = {
  width: "100%",
  paddingRight: 20,
  textAlign: "left",
  flex: 1
};

const OptionTitle = ({title, onClick}) => <div
  onClick={onClick}
  style={{
    ...containerStyle,
    textAlign: "left",
    position: "relative",
    paddingTop:5,
    cursor: "pointer",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap"
  }}
>
  {title}
</div>

OptionTitle.style = containerStyle;

export default OptionTitle;
